import { Outlet } from 'react-router-dom';
import { useTheme } from '@/lib/hooks/useTheme';
import { SiteFooter } from '@/features/layout/SiteFooter/SiteFooter';
import { TopBar } from '@/features/layout/TopBar/TopBar';
import styles from './AppShell.module.scss';

/** Chrome shared by every route: top bar, routed content, footer. */
export function AppShell() {
  const { theme, toggle } = useTheme();

  return (
    <div className={styles.shell}>
      <TopBar theme={theme} onToggleTheme={toggle} />
      <main className={styles.main}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
